export const PALETTE = {
  lagoon: 0x1aa6a1,
  deep: 0x0b3d4a,
  shallow: 0x4ecdc4,
  sand: 0xc4b18a,
  wetSand: 0x9a8866,
  concrete: 0xc9c4bb,
  whiteConcrete: 0xe6e4dc,
  steel: 0x1b2429,
  glass: 0x6aa0c2,
  coral: 0xe85a24,
  navy: 0x1b365d,
  yachtWhite: 0xf2f5f7,
  antifoul: 0x2a2422,
  teak: 0x8a5a32,
  palm: 0x2d6a4f,
  frond: 0x1f7a4d,
  rock: 0x3a3d40,
  cushion: 0xe85a24,
} as const;

export const WORLD = {
  waterLevel: 0,
  quayHeight: 1.18,
  basinHalfWidth: 40,
  basinSouth: -28,
  basinNorth: 36,
  entranceHalf: 12,
  breakwaterNorth: 58,
  seabed: -3.4,
} as const;

export type GerstnerWave = {
  dirX: number;
  dirZ: number;
  amplitude: number;
  wavelength: number;
  steepness: number;
};

/** Long swell from the open north, rolling onto shorelines, plus smaller chop. */
export const HARBOUR_WAVES: GerstnerWave[] = [
  { dirX: 0.12, dirZ: -0.993, amplitude: 1.05, wavelength: 148, steepness: 0.26 },
  { dirX: -0.2, dirZ: -0.98, amplitude: 0.52, wavelength: 86, steepness: 0.3 },
  { dirX: 0.32, dirZ: -0.947, amplitude: 0.26, wavelength: 48, steepness: 0.38 },
  { dirX: -0.58, dirZ: -0.815, amplitude: 0.11, wavelength: 23, steepness: 0.42 },
  { dirX: 0.7, dirZ: -0.714, amplitude: 0.06, wavelength: 12, steepness: 0.48 },
  { dirX: -0.88, dirZ: -0.475, amplitude: 0.035, wavelength: 6.5, steepness: 0.45 },
];

export const GRAVITY = 9.81;
